import type { AttendanceDashboardItem } from '@src/models/interfaces/attendanceDashboard.interface';

/**
 * Maps employee id → today's journey name(s) from attendance dashboard rows.
 * Multiple journeys for the same user are joined with ", ".
 */
export const buildJourneyNameByEmployeeId = (
  items: AttendanceDashboardItem[],
): Record<string, string> => {
  const map: Record<string, string> = {};

  items.forEach(item => {
    const employeeId = item.employeeId?.trim();
    const journeyName = item.journeyName?.trim();
    if (!employeeId || !journeyName) {
      return;
    }

    const existing = map[employeeId];
    if (!existing) {
      map[employeeId] = journeyName;
      return;
    }

    if (!existing.split(', ').includes(journeyName)) {
      map[employeeId] = `${existing}, ${journeyName}`;
    }
  });

  return map;
};
